export const MatchStatus = {
  Abandoned: 'Abandoned',
  Postponed: 'Postponed',
  NotKickedOff: 'NotKickedOff',
  FirstHalf: 'FirstHalf',
  HalfTime: 'HalfTime',
  SecondHalf: 'SecondHalf',
  FullTime: 'FullTime',
  FirstHalfOfExtraTime: 'FirstHalfOfExtraTime',
  HalfTimeInExtraTime: 'HalfTimeInExtraTime',
  SecondHalfOfExtraTime: 'SecondHalfOfExtraTime',
  FullTimeAfterExtraTime: 'FullTimeAfterExtraTime',
  PenaltyShootOut: 'PenaltyShootOut',

  // Streamline-specific statuses
  Live: 'Live',
} as const;
export type MatchStatus = (typeof MatchStatus)[keyof typeof MatchStatus];

/**
 * Valid phases for live feed events - only phases where match events can occur.
 * Events can only happen during active play, not during breaks or after the match.
 */
export type LiveFeedPhase =
  | typeof MatchStatus.FirstHalf
  | typeof MatchStatus.SecondHalf
  | typeof MatchStatus.FirstHalfOfExtraTime
  | typeof MatchStatus.SecondHalfOfExtraTime;
